import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Button, Icon } from "semantic-ui-react"
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import frLocale from '@fullcalendar/core/locales/fr';

import { TillService } from "../../services"
import { ErrorMessage, TillAssignationForm } from "../../components"
import { FeedbackMessage } from "../../constants"
import { Assignation, Till } from "../../models";


const CALENDAR_COLORS = [
  // Round 1 — une couleur par famille de teinte
  "#E53935", "#F4511E", "#FFB300", "#43A047", "#00ACC1",
  "#1E88E5", "#2962FF", "#5E35B1", "#8E24AA", "#D81B60",
  "#6D4C41", "#455A64", "#16A085", "#FB8C00", "#00C853",
  "#00897B", "#2F3542",
  // Round 2
  "#C62828", "#E64A19", "#FFA000", "#388E3C", "#0097A7",
  "#1976D2", "#304FFE", "#512DA8", "#7B1FA2", "#C2185B",
  "#5D4037", "#37474F", "#27AE60", "#F57C00", "#00A152",
  "#00796B", "#34495E",
  // Round 3
  "#D32F2F", "#D84315", "#FF8F00", "#2E7D32", "#00838F",
  "#1565C0", "#303F9F", "#4527A0", "#6A1B9A", "#AD1457",
  "#4E342E", "#263238", "#2980B9", "#EF6C00", "#009624",
  "#00695C", "#22313F",
  // Round 4
  "#B71C1C", "#BF360C", "#1B5E20", "#006064", "#0D47A1",
  "#311B92", "#4A148C", "#880E4F", "#3E2723", "#8E44AD",
  "#E65100", "#004D40",
  // SaaS restants
  "#C0392B", "#D35400", "#2C3E50", "#1ABC9C", "#3498DB", "#9B59B6",
];

const mapAssignationsToEvents = (l: Assignation[]) => {

    return l.map((a: Assignation) => {
        
        const colorIndex =  Number(a.userPhone) % CALENDAR_COLORS.length
        const endPlusOne = a.endDate ? new Date(a.endDate.getTime() + 86400000) : undefined

        return {
            id: a.assignmentId,
            title: a.userFirstname + ' ' + a.userLastname + '-' + a.userPhone,
            start: a.startDate,
            end: endPlusOne,
            allDay: true,
            backgroundColor: CALENDAR_COLORS[colorIndex],
            borderColor: CALENDAR_COLORS[colorIndex],
            textColor: '#fff',
            extendedProps: { cashierId: a.userId, cashierPhone: a.userPhone, status: 'confirmed' }
        }
    })
}

export function SupervisorTillsAssignationPage() {
    const { tillId } = useParams()

    const [errorFetchingAssignments, setErrorFetchingAssignments] = useState(false)
    const [assignationList, setAssignationList] = useState<Assignation[]>([])
    const [events, setEvents] = useState<any[]>([])
    const [assignModalVisible, setAssignModalVisible] = useState(false)

    const currentTill = new Till({ id: Number(tillId) })

    useEffect(() => {
        if (!tillId) return
        TillService.getTillAssignments(Number(tillId))
            .then(data => {
                setAssignationList(data)
            
                setEvents(mapAssignationsToEvents(data))
            })
            .catch(() => setErrorFetchingAssignments(true))
    }, [tillId])

    const navigate = useNavigate()

    const handleEventClick = (d: any) => {
        console.log(d)
    }
    
    return <div>
        <style>{`
            .fc .fc-toolbar-title { font-size: 1.1rem; font-weight: 700; }
            .fc .fc-button { border-radius: 6px !important; font-size: 0.85rem; }
            .fc .fc-button-primary { background: #f2711c; border-color: #f2711c; }
            .fc .fc-button-primary:hover { background: #e0600a; border-color: #e0600a; }
            .fc .fc-button-primary:not(:disabled).fc-button-active { background: #c9570a; border-color: #c9570a; }
            .fc .fc-daygrid-day-number { font-size: 0.85rem; }
            .fc .fc-col-header-cell { background: #fafafa; font-size: 0.82rem; text-transform: uppercase; letter-spacing: 0.05em; }
            .fc .fc-event { border-radius: 4px; }
            .fc .fc-button-group { gap: 4px; }
        `}</style>

        <div style={{ maxWidth: '1100px', margin: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>

            <Button basic icon onClick={() => navigate(-1)}>
                <Icon name='arrow left' /> Retour aux caisses
            </Button>

            <h2 style={{ margin: 0, color: '#000', fontWeight: 'bold' }}>Assignation Caisse {tillId}</h2>

            <Button color='orange' onClick={() => setAssignModalVisible(true)}>
                <Icon name='add circle' /> Assigner
            </Button>
        </div>

        {errorFetchingAssignments && <ErrorMessage errorText={FeedbackMessage.ASSIGNMENT_FETCH_ERROR} />}
        <div style={{ maxWidth: '1100px', margin: 'auto', boxShadow: '0 4px 24px rgba(0,0,0,0.10)', borderRadius: '16px', overflow: 'hidden', background: '#fff', padding: '24px' }}>
            <FullCalendar
                plugins={[dayGridPlugin]}
                initialView='dayGridMonth'
                weekends={true}
                events={events}
                eventContent={renderEventContent}
                locale={frLocale}
                dayHeaderFormat={{ weekday: 'long' }}
                eventClick={handleEventClick}
                headerToolbar={{ left: 'prev,next today', center: 'title', right: '' }}
                fixedWeekCount={false}
                dayMaxEvents={3}
                displayEventTime={false}
                aspectRatio={1.8}
                eventDisplay='block'
                nowIndicator={true}
            />
        </div>

        {assignModalVisible && <TillAssignationForm till={currentTill} setAssignModalVisible={setAssignModalVisible} />}
    </div>
}

function renderEventContent(eventInfo: any) {
    return (
        <span style={{ padding: '0 4px', fontWeight: 600, fontSize: '0.82em' }}>
            {eventInfo.event.title}
        </span>
    )
}
